// extracted by mini-css-extract-plugin
module.exports = {"errorLabel":"styles_errorLabel__FaZVb","warningLabel":"styles_warningLabel__2TX0R"};